
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map, switchMap, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';





import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class CasaService {

    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }
    searchForAccount(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.search(term)),);
    }

    search(searchString) {
        return this.http.get(`casa/account-number-name?accountNumberOrName=${searchString}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    searchGroupCASA(searchString, customerId) {
        return this.http.get(`casa/group-account-number?accountNumberOrName=${searchString}&customerId=${customerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    searchOverdraftCASA(searchString, customerId) {
        return this.http.get(`casa/overdraft-account-number?accountNumberOrName=${searchString}&customerId=${customerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAccountStatus(id) {
        let list: any = [
            { 'AccountStatusId': '1', 'AccountStatusName': 'Active' },
            { 'AccountStatusId': '2', 'AccountStatusName': 'Unapproved' },
            { 'AccountStatusId': '3', 'AccountStatusName': 'Dormant' },
            { 'AccountStatusId': '4', 'AccountStatusName': 'Closed' },
            { 'AccountStatusId': '5', 'AccountStatusName': 'Freeze' },
            { 'AccountStatusId': '6', 'AccountStatusName': 'Inactive' },
        ];
        let model = list.find(x => x.AccountStatusId == id);
        return (model == null) ? 'n/a' : model.AccountStatusName;
    }

    getOperation(id) {
        let list: any = [
            { 'OperationId': '1', 'Name': 'Revision' },
            { 'OperationId': '2', 'Name': 'Suspension' },
            { 'OperationId': '3', 'Name': 'Cancellation' },
            { 'OperationId': '4', 'Name': 'Termination' },
            { 'OperationId': '5', 'Name': 'Inactive' },
            { 'OperationId': '6', 'Name': 'Completed' },
        ];
        let model = list.find(x => x.OperationId == id);
        return (model == null) ? 'n/a' : model.Name;
    }

    getPostNoStatus(id) {
        let list: any = [
            { 'PostNoStatusId': '1', 'PostNoStatusName': 'None' },
            { 'PostNoStatusId': '2', 'PostNoStatusName': 'Post No Debit' },
            { 'PostNoStatusId': '3', 'PostNoStatusName': 'Post No Credit' },
            { 'PostNoStatusId': '4', 'PostNoStatusName': 'Post No Debit and Credit' },
        ];
        let model = list.find(x => x.PostNoStatusId == id);
        return (model == null) ? 'n/a' : model.PostNoStatusName;
    }

    getAccountByCustomerId(id) {
        return this.http.get(`casa/customer/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCustomerAccountBalance(accountNumber: string) {
        return this.http.get(`casa/customer-accounts/balance/${accountNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllCustomerAccountByCustomerId(id: number) {
        return this.http.get(`casa/customer-accounts/customer/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllCustomerAccountByCustomerIdandCurrency(id: number, currencyId: number) {
        return this.http.get(`casa/customer-accounts/customer/${id}/currency/${currencyId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getBusinessAccounts() {
        return this.http.get(`casa/business-accounts`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllCompanyChartOfAccounts() {
        return this.http.get(`setups/nostro-custom-chart-of-account/company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllCustomerAccount(customerId: number, loantypeid: number) {
        return this.http.get(`casa/customer-accounts/${customerId}/loantype/${loantypeid}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCustomerDetailedAccountByCustomerId(customerId: number) {
        return this.http.get(`casa/customer/${customerId}/account-details`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }



    fetchAndAddCustomerAccounts(bodyObj) {
        return this.http.post(`casa/customer-account-pull`,bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

// for drawdown memo
getDrawdownDeferralMemo() {
    //getDrawdownDeferralMemo(operationId, targetId) {
    //return this.http.get(`credit/get-drawdown-memo/${operationId}/operationId/${targetId}/targetId`)
    return this.http.get(`credit/get-drawdown-memo`)
        .map((res: Response) => res.json())
        .catch((error: any) => Observable
            .throw(error.json().error || 'Server error'));
  }
}